const state = {
    icalUrl: [],
};

export default state;